import Carousel from 'Assets/js/lib/carousel'
;(function () {
  const components = {
    ribbonNavigationCarousel: SAXX.Init.Component((node) => {
      new Carousel(node, { cell: '.ribbon-navigation--link-item' })
    }),
  }
  Object.assign(SAXX.Init.Components, components)
})()
